import React from 'react';
import Button from '../../../../composants/Button/Button';

interface ContratPreviewProps {
    candidatureId: number;
}

export default function ContratPreview({ candidatureId }: ContratPreviewProps) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');

    const handleDownload = async () => {
        try {
            const res = await fetch(
                `${apiUrl}/publications/ac27/contrats/${candidatureId}/telecharger`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (!res.ok) return;
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `contrat-signe-${candidatureId}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        } catch {
            // silently fail
        }
    };

    return (
        <div className="contrat-preview-container">
            <Button
                type="button"
                variant="secondary"
                value="Télécharger le contrat"
                onClick={handleDownload}
            />
        </div>
    );
}
